import { getAboutRequest } from "../repositories/about_repository";
export const AboutService = () => {
    const fetchAbout = async (setAboutData) => {
        try {
            const response = await getAboutRequest();
            if (response?.success) {
                setAboutData(response.data);
            }
        } catch (error) {
            console.error("Failed to fetch about data.");
        }
    };
    return {
        fetchAbout,
    };
};
